export const distinct = (value, index, self) =>{
    return self.indexOf(value) === index;
}